
import React from 'react';
import { Ticket, AppSettings } from '../types';

interface PrintableCheckInAgreementProps {
  ticket: Ticket;
  appSettings: AppSettings;
}

export const PrintableCheckInAgreement: React.FC<PrintableCheckInAgreementProps> = ({ ticket, appSettings }) => {
  if (!ticket || !appSettings) return null;

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric', month: 'long', day: 'numeric'
    });
  };

  return (
    <div className="p-4 font-sans text-xs leading-normal bg-white text-black">
      {appSettings.logoBase64 && (
        <div className="text-center mb-4">
          <img 
            src={appSettings.logoBase64} 
            alt={`${appSettings.companyName} Logo`} 
            className="mx-auto h-16 max-h-20 object-contain" 
          />
        </div>
      )}
      <h1 className="text-lg font-bold text-center mb-1">{appSettings.companyName}</h1>
      <h2 className="text-md font-semibold text-center mb-4">Service Intake Agreement</h2>

      <div className="grid grid-cols-2 gap-x-4 mb-4 text-xs">
        <div><strong>Ticket ID:</strong> {ticket.id}</div>
        <div><strong>Date:</strong> {formatDate(ticket.createdAt)}</div>
        <div><strong>Customer Name:</strong> {ticket.customer}</div>
        {ticket.customerPhoneNumber && <div><strong>Phone:</strong> {ticket.customerPhoneNumber}</div>}
        {ticket.customerEmail && <div className="col-span-2"><strong>Email:</strong> {ticket.customerEmail}</div>}
        <div className="col-span-2"><strong>Device Model:</strong> {ticket.deviceModel || 'N/A'}</div>
        {ticket.deviceSerialNumber && <div className="col-span-2"><strong>Serial Number:</strong> {ticket.deviceSerialNumber}</div>}
        <div className="col-span-2"><strong>Reported Issue:</strong> {ticket.subject}</div>
      </div>
      
      <div className="mb-4 p-3 border border-slate-300 rounded-md bg-slate-50 text-xs">
        <h3 className="font-semibold mb-1">Terms and Conditions:</h3>
        <p className="whitespace-pre-wrap">{appSettings.intakeAgreementText}</p>
      </div>

      <div className="mt-8 space-y-6 text-xs">
        <div className="flex justify-between items-end">
          <div className="w-2/5">
            <hr className="border-black mb-1" />
            <p>Customer Signature</p>
          </div>
          <div className="w-1/4">
            <hr className="border-black mb-1" />
            <p>Date</p>
          </div>
        </div>
        <div className="flex justify-start items-end pt-4">
            <div className="w-2/5">
                <hr className="border-black mb-1" />
                <p>{appSettings.companyName} Representative</p>
            </div>
        </div>
      </div>

      <p className="text-center text-[8pt] mt-6 text-slate-500">
        Please retain a copy of this agreement for your records.
      </p>
    </div>
  );
};
